import { render, staticRenderFns } from "./SSelectSuperviceProducer.vue?vue&type=template&id=b50b2ca8"
import script from "./SSelectSuperviceProducer.vue?vue&type=script&lang=js"
export * from "./SSelectSuperviceProducer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports